<template>
  <div class='provisioning-services-settings'>
    <dean-two-column-layout :title="headerTitle">
      <dean-section-title-item
          :icon="saveIcon"
          slot="title-items"
          :content="true"
          :large="true"
          @click.native="save"
      >
        Opslaan
      </dean-section-title-item>

      <div class="column" slot="left">
        <fade-transition group>
          <dean-form-row key="name" id="name" label="Name" v-model="data.name" type="text" :required-field="true"
                         :warning="$v.data.name.$error" @focus="$v.data.name.$touch()"/>


          <dean-input-switch-form-row
              key="isOption" id="isOption" :value="data.isOption" @checked="isOptionChanged"
              label="Option product"></dean-input-switch-form-row>


          <dean-form-row key="subscriptionUuid" id="subscriptionUuid" label="Subscription uuid"
                         v-model="data.subscriptionUuid" type="text"
                         :required-field="!this.disableMainProductFields"
                         :disabled="this.disableMainProductFields"
                         :warning="$v.data.subscriptionUuid.$error" @focus="$v.data.subscriptionUuid.$touch()"
          />

          <dean-form-row key="subscriptionName" id="subscriptionName" label="Subscription name"
                         v-model="data.subscriptionName" type="text"
                         :required-field="!this.disableMainProductFields"
                         :disabled="this.disableMainProductFields"
                         :warning="$v.data.subscriptionName.$error" @focus="$v.data.subscriptionName.$touch()"/>

          <dean-form-row key="ratePlanUuid" id="ratePlanUuid" label="Rate plan uuid"
                         v-model="data.ratePlanUuid" type="text"
                         :required-field="!this.disableMainProductFields"
                         :disabled="this.disableMainProductFields"
                         :warning="$v.data.ratePlanUuid.$error" @focus="$v.data.ratePlanUuid.$touch()"/>

          <dean-form-row key="ratePlanName" id="ratePlanName" label="Rate plan name"
                         v-model="data.ratePlanName" type="text"
                         :required-field="!this.disableMainProductFields"
                         :disabled="this.disableMainProductFields"
                         :warning="$v.data.ratePlanName.$error" @focus="$v.data.ratePlanName.$touch()"/>

          <dean-form-row key="bundleUuid" id="bundleUuid" label="Bundle uuid"
                         v-model="data.bundleUuid" type="text"
                         :required-field="!this.disableMainProductFields"
                         :disabled="this.disableMainProductFields"
                         :warning="$v.data.bundleUuid.$error" @focus="$v.data.bundleUuid.$touch()"/>

          <dean-form-row key="bundleName" id="bundleName" label="Bundle name"
                         v-model="data.bundleName" type="text"
                         :required-field="!this.disableMainProductFields"
                         :disabled="this.disableMainProductFields"
                         :warning="$v.data.bundleName.$error" @focus="$v.data.bundleName.$touch()"/>

          <dean-form-row key="physicalSimUuid" id="physicalSimUuid" label="Physical sim uuid"
                         v-model="data.physicalSimUuid" type="text"
                         :required-field="!this.disableMainProductFields"
                         :disabled="this.disableMainProductFields"
                         :warning="$v.data.physicalSimUuid.$error" @focus="$v.data.physicalSimUuid.$touch()"/>

          <dean-form-row key="physicalSimName" id="physicalSimName" label="Physical sim name"
                         v-model="data.physicalSimName" type="text"
                         :required-field="!this.disableMainProductFields"
                         :disabled="this.disableMainProductFields"
                         :warning="$v.data.physicalSimName.$error" @focus="$v.data.physicalSimName.$touch()"/>

          <dean-form-row key="physicalSimClass" id="physicalSimClass" label="Physical sim class"
                         v-model="data.physicalSimClass" type="text"
                         :required-field="!this.disableMainProductFields"
                         :disabled="this.disableMainProductFields"
                         :warning="$v.data.physicalSimClass.$error" @focus="$v.data.physicalSimClass.$touch()"/>

          <dean-form-row key="physicalSimMaterialCode" id="physicalSimMaterialCode" label="Physical sim material code"
                         v-model="data.physicalSimMaterialCode" type="text"
                         :required-field="!this.disableMainProductFields"
                         :disabled="this.disableMainProductFields"
                         :warning="$v.data.physicalSimMaterialCode.$error" @focus="$v.data.physicalSimMaterialCode.$touch()"/>

          <dean-form-row key="eSimUuid" id="eSimUuid" label="eSim uuid"
                         v-model="data.eSimUuid" type="text"
                         :required-field="!this.disableMainProductFields"
                         :disabled="this.disableMainProductFields"
                         :warning="$v.data.eSimUuid.$error" @focus="$v.data.eSimUuid.$touch()"/>

          <dean-form-row key="eSimName" id="eSimName" label="eSim name"
                         v-model="data.eSimName" type="text"
                         :required-field="!this.disableMainProductFields"
                         :disabled="this.disableMainProductFields"
                         :warning="$v.data.eSimName.$error" @focus="$v.data.eSimName.$touch()"/>

          <dean-form-row key="eSimClass" id="eSimClass" label="eSim class"
                         v-model="data.eSimClass" type="text"
                         :required-field="!this.disableMainProductFields"
                         :disabled="this.disableMainProductFields"
                         :warning="$v.data.eSimClass.$error" @focus="$v.data.eSimClass.$touch()"/>

          <dean-form-row key="eSimMaterialCode" id="eSimMaterialCode" label="eSim material code"
                         v-model="data.eSimMaterialCode" type="text"
                         :required-field="!this.disableMainProductFields"
                         :disabled="this.disableMainProductFields"
                         :warning="$v.data.eSimMaterialCode.$error" @focus="$v.data.eSimMaterialCode.$touch()"/>

          <dean-form-row key="optionUuid" id="optionUuid" label="Option uuid"
                         v-model="data.optionUuid" type="text"
                         :required-field="this.disableMainProductFields"
                         :disabled="!this.disableMainProductFields"
                         :warning="$v.data.optionUuid.$error" @focus="$v.data.optionUuid.$touch()"/>

          <dean-form-row key="optionName" id="optionName" label="Option name"
                         v-model="data.optionName" type="text"
                         :required-field="this.disableMainProductFields"
                         :disabled="!this.disableMainProductFields"
                         :warning="$v.data.optionName.$error" @focus="$v.data.optionName.$touch()"/>

        </fade-transition>
      </div>

    </dean-two-column-layout>
  </div>
</template>

<script lang="ts">
import {Vue, Component} from 'vue-property-decorator';
import {
  deanSectionTitleItem,
  saveIcon,
} from '@deanone/dean-components';
import DeanFormRow from '@/components/deanComponents/deanFormRow.vue';
import DeanTwoColumnLayout from '@/components/deanComponents/deanTwoColumnLayout.vue';
import deanInputSwitchFormRow from '@/components/deanComponents/deanInputSwitchFormRow.vue';
import deanSelectFormRow from '@/components/deanComponents/deanSelectFormRow.vue';
import deanMultiSelectFormRow from '@/components/deanComponents/deanMultiSelectFormRow.vue';
import {FadeTransition} from 'vue2-transitions';
import {validationMixin} from 'vuelidate';
import {required, requiredIf} from 'vuelidate/lib/validators';
import {Validations} from 'vuelidate-property-decorators';
import {createNotification} from '@/mixins/validations';
import {processOdidoProducts} from "@/store/standingData/actions";

@Component({
  components: {
    deanInputSwitchFormRow,
    deanSectionTitleItem,
    DeanFormRow,
    DeanTwoColumnLayout,
    deanSelectFormRow,
    deanMultiSelectFormRow,
    FadeTransition,
  },
  mixins: [validationMixin],
})
export default class Details extends Vue {
  // DATA
  public data: any = {
    name: '',
    subscriptionUuid: '',
    subscriptionName: '',
    ratePlanUuid: '',
    ratePlanName: '',
    bundleUuid: '',
    bundleName: '',
    physicalSimUuid: '',
    physicalSimName: '',
    physicalSimClass: '',
    physicalSimMaterialCode: '',
    eSimUuid: '',
    eSimName: '',
    eSimClass: '',
    eSimMaterialCode: '',
    optionUuid: '',
    optionName: '',
    isOption: false,
  };
  public name: string = '';
  public saveIcon: any = saveIcon;
  public disableMainProductFields: boolean = false;

  // COMPUTED
  @Validations()
  get validations() {
    return {
      data: {
        name: {required},
        subscriptionUuid: {
          required: requiredIf(() => {
            return !this.data.isOption;
          }),
        },
        subscriptionName: {
          required: requiredIf(() => {
            return !this.data.isOption;
          }),
        },
        ratePlanUuid: {
          required: requiredIf(() => {
            return !this.data.isOption;
          }),
        },
        ratePlanName: {
          required: requiredIf(() => {
            return !this.data.isOption;
          }),
        },
        bundleUuid: {
          required: requiredIf(() => {
            return !this.data.isOption;
          }),
        },
        bundleName: {
          required: requiredIf(() => {
            return !this.data.isOption;
          }),
        },
        physicalSimUuid: {
          required: requiredIf(() => {
            return !this.data.isOption;
          }),
        },
        physicalSimName: {
          required: requiredIf(() => {
            return !this.data.isOption;
          }),
        },
        physicalSimClass: {
          required: requiredIf(() => {
            return !this.data.isOption;
          }),
        },
        physicalSimMaterialCode: {
          required: requiredIf(() => {
            return !this.data.isOption;
          }),
        },
        eSimUuid: {
          required: requiredIf(() => {
            return !this.data.isOption;
          }),
        },
        eSimName: {
          required: requiredIf(() => {
            return !this.data.isOption;
          }),
        },
        eSimClass: {
          required: requiredIf(() => {
            return !this.data.isOption;
          }),
        },
        eSimMaterialCode: {
          required: requiredIf(() => {
            return !this.data.isOption;
          }),
        },
        optionUuid: {
          required: requiredIf(() => {
            return this.data.isOption;
          }),
        },
        optionName: {
          required: requiredIf(() => {
            return this.data.isOption;
          }),
        },
      }
    };
  }

  get headerTitle(): string {
    return (this.$route.params.id !== undefined) ? 'Odido Product wijzigen' : 'Odido Product toevoegen';
  }

  get sideMenu(): object {
    return {
      content: {
        title: {
          text: 'producten ' + (this.name ? this.name : 'toevoegen'),
        },
        type: 'themed',
        sections: {
          general: {
            items: {
              backGroup: {
                title: 'Terug naar Odido producten',
                name: 'standingData.odidoProducts',
              },
              backCommissions: {
                title: 'Terug naar producten',
                name: 'standingData.products',
              },
            },
          },
        },
      },
    };
  }

  public save() {

    this.trimInputs();

    this.$v.$touch();
    if (!this.$v.$invalid) {
      this.$store.dispatch('setLoadOverlay', true);

      this.$store.dispatch('processOdidoProducts', {
        identifier: this.$route.params.id,
        name: this.data.name,
        subscriptionUuid: this.data.subscriptionUuid,
        subscriptionName: this.data.subscriptionName,
        ratePlanUuid: this.data.ratePlanUuid,
        ratePlanName: this.data.ratePlanName,
        bundleUuid: this.data.bundleUuid,
        bundleName: this.data.bundleName,
        physicalSimUuid: this.data.physicalSimUuid,
        physicalSimName: this.data.physicalSimName,
        physicalSimClass: this.data.physicalSimClass,
        physicalSimMaterialCode: this.data.physicalSimMaterialCode,
        eSimUuid: this.data.eSimUuid,
        eSimName: this.data.eSimName,
        eSimClass: this.data.eSimClass,
        eSimMaterialCode: this.data.eSimMaterialCode,
        optionUuid: this.data.optionUuid,
        optionName: this.data.optionName,
        isOption: this.data.isOption,
      }).then(
          (response: any) => {
            this.$toast(this.$store.state.main.notification.messages.dataSaved);
          },
          (error: any) => {
            this.$toast(this.$store.state.main.notification.messages.couldNotSendData);
          },
      ).finally(() => {
        this.$store.dispatch('setLoadOverlay', false);
      });
    } else {
      this.$toast(createNotification(this.$v));
    }
  }

  public created() {
    if (this.$route.params.id) {
      this.$store.dispatch('setLoadOverlay', true);
      this.$store.dispatch('requestOdidoProduct', {id: this.$route.params.id})
          .then(
              (response: any) => {
                this.data.name = response.data.name;
                this.data.subscriptionUuid = response.data.subscriptionUuid;
                this.data.subscriptionName = response.data.subscriptionName;
                this.data.ratePlanUuid = response.data.ratePlanUuid;
                this.data.ratePlanName = response.data.ratePlanName;
                this.data.bundleUuid = response.data.bundleUuid;
                this.data.bundleName = response.data.bundleName;
                this.data.physicalSimUuid = response.data.physicalSimUuid;
                this.data.physicalSimName = response.data.physicalSimName;
                this.data.physicalSimClass = response.data.physicalSimClass;
                this.data.physicalSimMaterialCode = response.data.physicalSimMaterialCode;
                this.data.eSimUuid = response.data.eSimUuid;
                this.data.eSimName = response.data.eSimName;
                this.data.eSimClass = response.data.eSimClass;
                this.data.eSimMaterialCode = response.data.eSimMaterialCode;
                this.data.optionUuid = response.data.optionUuid;
                this.data.optionName = response.data.optionName;
                this.data.isOption = response.data.type === 'option';

                this.name = this.data.name;
                this.disableMainProductFields = this.data.isOption;
              },
              (error) => {
                this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
              },
          ).finally(() => {
        this.$store.commit('SET_SIDEMENU', this.sideMenu);
        this.$store.dispatch('setLoadOverlay', false);
      });
    }

    this.$store.commit('SET_SIDEMENU', this.sideMenu);
  }

  public isOptionChanged(field: { value: any }) {
    this.data.isOption = field.value;
    this.disableMainProductFields = field.value;

    if (field.value) {
      this.data.subscriptionUuid = '';
      this.data.subscriptionName = '';
      this.data.ratePlanUuid = '';
      this.data.ratePlanName = '';
      this.data.bundleUuid = '';
      this.data.bundleName = '';
      this.data.physicalSimUuid = '';
      this.data.physicalSimName = '';
      this.data.physicalSimClass = '';
      this.data.physicalSimMaterialCode = '';
      this.data.eSimUuid = '';
      this.data.eSimName = '';
      this.data.eSimClass = '';
      this.data.eSimMaterialCode = '';
    } else {
      this.data.optionUuid = '';
      this.data.optionName = '';
    }
  }

  private trimInputs() {
    this.data.subscriptionUuid = this.data.subscriptionUuid?.trim();
    this.data.subscriptionName = this.data.subscriptionName?.trim();
    this.data.ratePlanUuid = this.data.ratePlanUuid?.trim();
    this.data.ratePlanName = this.data.ratePlanName?.trim();
    this.data.bundleUuid = this.data.bundleUuid?.trim();
    this.data.bundleName = this.data.bundleName?.trim();
    this.data.physicalSimUuid = this.data.physicalSimUuid?.trim();
    this.data.physicalSimName = this.data.physicalSimName?.trim();
    this.data.physicalSimName = this.data.physicalSimName?.trim();
    this.data.physicalSimClass = this.data.physicalSimClass?.trim();
    this.data.physicalSimMaterialCode = this.data.physicalSimMaterialCode?.trim();
    this.data.eSimUuid = this.data.eSimUuid?.trim();
    this.data.eSimName = this.data.eSimName?.trim();
    this.data.eSimClass = this.data.eSimClass?.trim();
    this.data.eSimMaterialCode = this.data.eSimMaterialCode?.trim();
    this.data.optionUuid = this.data.optionUuid?.trim();
    this.data.optionName = this.data.optionName?.trim();
  }
}
</script>

<style lang="scss" scoped>

</style>
